import appSettings from 'wanderu-config';
import {
    actionDuckUtils,
} from 'wanderu-ducks-utils';
import {
    selectLocale,
} from 'wanderu-i18n';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';

import { actions as reviewFeedActions } from '../../appstate/reviewFeed';
import { getReviewFeedContent } from '../../services/seoService';
import sliceNamespace from '../../types';

const namespace = 'ACTIONS/FETCH_REVIEW_FEED';
const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace);

const logger = Logger.getLogger('fetchReviewFeed');

function fetchReviews(reviewName, reviewId, reviewType) {
    return async function(dispatch, getState) {
        let error = null;

        dispatch(actions.startWork(reviewName));

        try {
            const locale = selectLocale(getState());
            const { result } = await getReviewFeedContent(reviewId, locale, reviewType);

            if (result && result.length === 0) {
                const error = { code: 'END_OF_FEED' };
                throw error;
            }

            dispatch(reviewFeedActions.setReviewFeedContent(result, reviewName));
            return result;
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });
            error = {
                code: ex.code,
                message: 'set review feed failed',
                name: ex.code,
            };
        } finally {
            dispatch(actions.endWork(reviewName, undefined, error));
        }
    };
}

const fetchReviewFeedSelectors = {
    ...selectors,
    selectNotFound(appState, id) {
        const opStatus = selectors.idSelector(appState, id);

        return opStatus
            && opStatus.error
            && opStatus.error.code === 'INVALID_REVIEW_ID';
    },
    selectEndOfFeed(appState, id) {
        const opStatus = selectors.idSelector(appState, id);

        return opStatus
            && opStatus.error
            && opStatus.error.code === 'END_OF_FEED';
    },
};

const fetchReviewFeedAction = {
    fetchReviews,
    ...fetchReviewFeedSelectors,
};

export {
    fetchReviewFeedAction,
    namespace,
};

export default {
    [namespace]: reducer,
};
